<template>
  <div class="flex flex-col items-center text-center p-8">
    <FontAwesomeIcon icon="fa-regular fa-circle-check" style="height: 240px; color: #36ff04" />
    <div class="text-xl mt-8">
      Vielen Dank für Ihre Anfrage. Diese wurde erfolgreich an uns übermittelt. Wir werden uns in
      Kürze mit einem individuellen Angebot bei Ihnen melden.<br />
      <div v-if="requestStore.responseData.purchasePriceGrossRounded !== null">
        Unser vorläufiges Angebot beträgt
        <span class="text-brand font-semibold"> {{ purchasePrice }} €</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRequestStore } from '../../requestStore.js'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
const requestStore = useRequestStore()

const purchasePrice = requestStore.responseData.purchasePriceGrossRounded
</script>
